<section class="welcome-banner">
  <nz-carousel
    nzAutoPlay
    [nzAutoPlaySpeed]="6000"
    nzEffect="scrollx"
    [nzDots]="true">
    <div
      nz-carousel-content
      class="welcome-banner__slide welcome-banner__slide--welcome"
      [style.background-image]="'url(' + welcomeBannerImage + ')'">
      <div class="welcome-banner__content">
        <div class="welcome-banner__head">
          <h2 class="welcome-banner__title">Xin chào, {{ displayName }}!</h2>
          <p class="welcome-banner__subtitle">{{ welcomeSubtitle }}</p>
        </div>
        <div class="welcome-banner__meta">
          <div class="welcome-banner__field">
            <span class="welcome-banner__field-label">Đăng nhập gần nhất</span>
            <span class="welcome-banner__field-value">{{ lastLoginDisplay }}</span>
          </div>
        </div>
      </div>
    </div>

    <div
      nz-carousel-content
      class="welcome-banner__slide welcome-banner__slide--event"
      [style.background-image]="'url(' + eventBannerImage + ')'">
<!--      <div class="welcome-banner__content">-->
<!--        <span class="welcome-banner__badge">{{ eventBanner.badge }}</span>-->
<!--        <h2 class="welcome-banner__title">{{ eventBanner.title }}</h2>-->
<!--        <p class="welcome-banner__subtitle">{{ eventBanner.subtitle }}</p>-->
<!--        <p class="welcome-banner__description">{{ eventBanner.description }}</p>-->
<!--      </div>-->
    </div>
  </nz-carousel>
</section>
